/**
 * Customize this function to fill draft of wizard forms from from a wizardContext object
 * @param $configWizard
 * @param $router
 * @param draft
 */
const fillDraft = ({ wizard, router, draft }) => {
  // console.debug('Customize this function to fill wizard draft form', wizard, router, draft);
};

export default {
  fillDraft,
};
